import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import LoadingIndicator from './components/layout/LoadingIndicator'
import SomethingWentWrongIndicator from './components/layout/SomethingWentWrongIndicator'
import { trackPromise } from 'react-promise-tracker'
import axios from 'axios'
import Toolbar from './components/layout/toolbar/Toolbar'
import Menu from './components/layout/menu/Menu'
import { Content } from './components/layout/Content'
/*import './css/App.css'*/
import { library } from '@fortawesome/fontawesome-svg-core'
import {  faWarehouse, faBoxOpen, faBoxes, faCog,
          faDollyFlatbed, faPaperclip,
          faChartLine, faCogs, faPeopleCarry,
          faPlus, faTimes, faSyncAlt, faEdit,
          faTrash, faAngleLeft, faAngleRight,
          faExclamation, faListAlt, faExclamationCircle,
          faEllipsisV, faSave, faSortNumericDownAlt,
          faSortNumericUp, faSortAlphaDownAlt, faSortAlphaUp,
          faBars, faCoffee, faPrint, faCoins, faPercent,
          faCheck, faArrowDown, faSquare, faCheckSquare,
          faReceipt, faUser, faTachometerAlt, faSearch,
          faCaretRight, faCaretLeft, faCaretDown, faTools,
          faPowerOff, faUserFriends, faUndo, faArrowLeft,
          faUndoAlt

       } from '@fortawesome/free-solid-svg-icons'

// Add fontawesome icons that I just need on the library
library.add (
  faWarehouse, faBoxOpen, faBoxes, faBars,
  faDollyFlatbed, faPaperclip, faChartLine,
  faCogs, faPeopleCarry, faPlus, faTimes,
  faSyncAlt, faEdit, faTrash, faAngleLeft,
  faAngleRight, faExclamation, faListAlt,
  faExclamationCircle, faEllipsisV, faSave,
  faSortNumericDownAlt, faSortNumericUp,
  faSortAlphaDownAlt, faSortAlphaUp, faCog,
  faCoffee, faPrint, faCoins, faPercent,
  faCheck, faArrowDown, faSquare, faSearch,
  faCheckSquare, faReceipt, faUser, faTachometerAlt,
  faCaretRight, faCaretLeft, faCaretDown, faTools,
  faPowerOff, faUserFriends, faUndo, faArrowLeft,
  faUndoAlt
)

export const appContext = React.createContext()

function useApp(props) {
  const [content, setContent] = useState('')
  const loading_message = 'Loading data, pleases wait...'
  const [showDropDownWindow, setShowDropDownWindow] = useState(null)
  const [client, setClient] = useState(props.client)
  const clientID = props.client._id

  // Global axios header
  axios.defaults.headers.common['client'] = JSON.stringify(client)

  // Get current client date and time (time zoned)
  // this might be wrong
  const getClientDateTime = () => new Date().toLocaleString('en-Us', { timeZone: client.company_address.time_zone, dateStyle: "medium", timeStyle: "long" });
  const getClientTimezone = () => client.company_address.time_zone;

  const logOut = async () => {
    let  log_out = null

    startLoadingIndicator("Logging out")
    await trackPromise (
      axios.post(process.env.REACT_APP_API_URI + '/clients/logout')
      .then(async (result) => {
        log_out = result.data
        stopLoadingIndicator()
      })
      .catch(error => { errorLoadingIndicator(error) })
    )

    return log_out
  }

  const resetClient = async (updated_client) => { setClient({...updated_client, signed_in: client.signed_in}) }

  function startLoadingIndicator(message) {
    const lic = document.getElementById("loading-indicator-container")
    if (!message) message = loading_message
    ReactDOM.render(<LoadingIndicator loading_message={message}/>, lic)
  }

  function stopLoadingIndicator() {
    const lic = document.getElementById("loading-indicator-container")
    ReactDOM.unmountComponentAtNode(lic)
  }

  function errorLoadingIndicator(error) {
    const lic = document.getElementById("loading-indicator-container")
    ReactDOM.render(<SomethingWentWrongIndicator error={error}/>, lic)
  }

  useEffect(() => {
    //console.log(client)
  }, [client])

  return ({
    content: [content, setContent],
    showDropDownWindow: [showDropDownWindow, setShowDropDownWindow],
    startLoadingIndicator,
    stopLoadingIndicator,
    errorLoadingIndicator,
    getClientDateTime,
    getClientTimezone,
    logOut,
    client,
    resetClient,
    clientID,
    API_URI: process.env.REACT_APP_API_URI,
    API_KEY: process.env.REACT_APP_API_KEY,
    APP_HOST: process.env.REACT_APP_HOST
  })
}

function App(props) {
  const app = useApp(props)
  const content = app.content[0]
  const setShowDropDownWindow = app.showDropDownWindow[1]

  // Global axios header
  axios.defaults.headers.common['client-id'] = app.clientID

  const removeAutoCompleteList = () => {
    //Unmount autocompleteList when it's visible upon clicking outside it's range
    const onClickListener = (e) => {
      // Hide/clear AutoCompleteList
      const acl_container = document.querySelectorAll('.acl-container')
      const autocomplete_list = document.getElementById('autocomplete-list')
      if (autocomplete_list)
        if(!(e.target.className === 'autocomplete-list-item'))
          acl_container.forEach((item, i) => {
            ReactDOM.unmountComponentAtNode(item)
          })

      //Hide/clear DropDownWindow
      //if and only if click is not comming from a closest container dropdown-window
      if (!e.target.closest('#dropdown-window')) {
        const ddwindows = document.querySelectorAll('.dd-window-container')
        if (ddwindows.length > 0) {
          ddwindows.forEach((item, i) => {
            ReactDOM.unmountComponentAtNode(document.getElementById(item.id))
          })
        }
        if (!(e.target.closest('.item-option-drop'))) setShowDropDownWindow(null)
      }

      // Hide dropwdown window in Toolbar current user loged-in button
      const btn = e.target.closest('#client-user-button')
      const ddw = document.querySelector('.dropdown-window')
      if (btn) {
        if (btn.id === 'client-user-button') {
          const isShow = ddw.classList.contains('show')
          if (isShow) ddw.classList.remove('show')
          else ddw.classList.add('show')
        }
      } else {
          const ddw = document.querySelector('.dropdown-window')
          if (ddw) {
            const isShow = ddw.classList.contains('show')
            if (isShow) ddw.classList.remove('show')
          }
      }

      // Hide action-btn-menu of Invoice, StockIn and StockOut
      if (!(e.target.closest('.ellips-btn'))) {
        const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
        action_btn_menu_all.forEach(act_btn => {
          act_btn.classList.remove('show-dd-menu')
        })
      }
    }

    const container = document.querySelector('.container')
    container.addEventListener('click', onClickListener)
  }

  /* Create initial Settings Collections */
  const createSettingsCollection = () => {
    axios.post(process.env.REACT_APP_API_URI + '/settings/create')
      .then(result => {
        if (result.data.status === 1) { /** console.log('settings good') */ }
      })
      .catch(err => {
        throw err
      })
  }

  /* Create initial Warehouses Collections */
  const createWarehousesCollection = () => {
    axios.post(process.env.REACT_APP_API_URI + '/warehouses/create')
      .then(result => {
        if (result.data.status === 1) { /** console.log('warehouse is good') */ }
      })
      .catch(err => {
        throw err
      })
  }

  useEffect(() => {
    removeAutoCompleteList()
    createSettingsCollection()
    createWarehousesCollection()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <appContext.Provider value={app}>
      {/*<div id="modal-form-container"></div>*/}
      <div className="container">
        <Toolbar />
        <Menu />
        <Content content={content}/>
      </div>
    </appContext.Provider>
  )
}

export default React.memo(App)